import gql from 'graphql-tag';

export const baseUserSettingsFragment = gql`
  fragment baseUserSettings on UserSettings {
    viewName
    columns {
      header
      binding
      isReadOnly
      visible
      wordWrap
      size
      align
      format
      isContentHtml
      aggregate
    }
    sorting {
      property
      ascending
    }
    frozenColumns
    groups
    notifications {
      id
      moduleName
      namespace
      anouncements
    }
    accountType
    repCode
    filterDefinition
  }
`;
